(function () {
  // Run alleen op collectiepagina's
  if (!/\/collections\//.test(location.pathname)) return;

  function getParams(){ return new URLSearchParams(window.location.search); }
  function isOn(){ return getParams().getAll('filter.v.availability').includes('1'); }
  function setAndGo(on){
    const p = getParams();
    if(on) p.set('filter.v.availability','1'); 
    else   p.delete('filter.v.availability');
    const url = location.pathname + (p.toString() ? '?' + p : '');
    location.assign(url);
  }

  function mount(){
    if (document.querySelector('.muki-stock-toggle')) return;

    const wrap = document.createElement('div');
    wrap.className = 'muki-stock-toggle';
    wrap.innerHTML = `
      <label>
        <input type="checkbox" ${isOn() ? 'checked' : ''} aria-label="Alleen op voorraad">
        <span class="muki-switch"></span>
        <span class="muki-text">Alleen op voorraad</span>
      </label>
    `;

    // Plaats NA de "Filters"-knop (niet tegen de linkerrand)
    const filtersBtn = document.querySelector('[data-drawer-toggle], .facets__open-button, button[aria-controls*="Facet"]');
    if (filtersBtn && filtersBtn.parentElement) {
      const row = filtersBtn.parentElement;
      row.classList.add('muki-filters-row');
      row.insertBefore(wrap, filtersBtn.nextSibling);
    } else {
      // Fallback: boven het grid
      const header = document.querySelector('.collection, .collection__tools, .product-grid');
      (header?.parentElement || document.body).insertBefore(wrap, header || document.body.firstChild);
    }

    wrap.querySelector('input').addEventListener('change', e => setAndGo(e.target.checked));
  }

  document.addEventListener('DOMContentLoaded', mount);
})();
